import React from 'react';
import { useTranslation } from 'react-i18next';

const Japan = () => {
    const { t } = useTranslation();

    const heroImage =
        'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1600&q=80';
    const aboutImage =
        'https://images.unsplash.com/photo-1526481280693-3bfa7568e0f3?auto=format&fit=crop&w=1200&q=80';

    return (
        <div className="bg-[#07111f] text-white">
            <section className="relative overflow-hidden">
                <img
                    src={heroImage}
                    alt={t('japanHeroImageAlt')}
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#07111f]/90 via-[#07111f]/75 to-[#07111f]/40" />

                <div className="relative mx-auto flex min-h-[78vh] max-w-7xl items-center px-6 py-24 sm:px-10 lg:px-16">
                    <div className="max-w-3xl">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-[#f7d774]">
                            {t('japanHeroEyebrow')}
                        </p>
                        <h1 className="font-serif text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
                            <span className="block text-[#7fd3ff]">{t('japanHeroTitle')}</span>
                        </h1>
                        <p className="mt-6 text-lg leading-8 text-white/90 sm:text-xl">
                            {t('japanHeroSubtitle')}
                        </p>
                    </div>
                </div>
            </section>

            {/* ABOUT SECTION */}
            <section className="mx-auto max-w-7xl px-6 py-20 sm:px-10 lg:px-16">
                <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
                    {/* Mobile layout - visible only on small screens */}
                    <div className="block sm:hidden">
                        <div className="p-8 text-center">
                            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-[#7fd3ff]">
                                {t('japanAboutEyebrow')}
                            </p>
                            <h2 className="font-serif text-3xl font-semibold text-white">
                                {t('japanSectionTitle')}
                            </h2>
                            <img
                                src={aboutImage}
                                alt={t('japanSectionImageAlt')}
                                className="mt-6 h-[280px] w-full rounded-[1.25rem] object-cover"
                            />
                            <p className="mt-6 text-base leading-7 text-white/80">
                                {t('japanSectionDescription')}
                            </p>
                        </div>
                    </div>

                    {/* Desktop layout - hidden on small screens */}
                    <div className="hidden sm:flex lg:flex-row">
                        <div className="flex-1 p-8 sm:p-12 lg:p-16">
                            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-[#7fd3ff]">
                                {t('japanAboutEyebrow')}
                            </p>
                            <h2 className="font-serif text-3xl font-semibold text-white sm:text-4xl">
                                {t('japanSectionTitle')}
                            </h2>
                            <p className="mt-6 text-lg leading-8 text-white/80">
                                {t('japanSectionDescription')}
                            </p>
                        </div>

                        <div className="flex-1">
                            <img
                                src={aboutImage}
                                alt={t('japanSectionImageAlt')}
                                className="h-full min-h-[280px] w-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Japan;
